import Reveal from "./Reveal";
import { IMAGES, whatsappLink } from "@/constants/site";

export default function Restaurant() {
  const waLink = whatsappLink(
    "Merhaba Düzbağ Life, restaurant hakkında bilgi almak istiyorum."
  );

  return (
    <section id="restaurant" className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Images */}
          <Reveal>
            <div className="space-y-3 md:space-y-4">
              <div className="w-full h-[260px] md:h-[380px] rounded-lg overflow-hidden">
                <img
                  src={IMAGES.restaurant}
                  alt="Düzbağ Life Restaurant iç mekan"
                  title="Düzbağ Life Restaurant"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-3 md:gap-4">
                <div className="w-full h-[150px] md:h-[200px] rounded-lg overflow-hidden">
                  <img
                    src={IMAGES.garden}
                    alt="Düzbağ Life bahçe ve A-frame manzarası"
                    title="Düzbağ Life restaurant manzarası"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-[150px] md:h-[200px] rounded-lg overflow-hidden">
                  <img
                    src={IMAGES.livingStove}
                    alt="Düzbağ Life sıcak iç mekan atmosferi"
                    title="Düzbağ Life restaurant atmosferi"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </Reveal>

          {/* Text */}
          <Reveal delay={120}>
            <span className="text-secondary-600 text-xs tracking-[0.3em] uppercase">
              Lezzet & Sofra
            </span>
            <h2 className="mt-5 font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-[1.15] font-medium">
              DÜZBAĞ LIFE
              <br />
              RESTAURANT
            </h2>
            <div className="mt-6 h-px w-16 bg-accent-500" />
            <p className="mt-6 text-foreground-700 text-base md:text-lg leading-relaxed">
              Doğanın ortasında güzel bir gün, güzel bir sofrayla tamamlanır.
            </p>
            <p className="mt-4 text-foreground-600 text-sm md:text-base leading-relaxed">
              Konaklayan misafirlerimizin yanı sıra restaurant deneyimi için
              gelen ziyaretçilerimizi de sıcak ve samimi bir atmosferde
              ağırlıyoruz.
            </p>
            <a
              href={waLink}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-flex items-center gap-2 bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold px-7 py-3.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <i className="ri-whatsapp-line text-lg" />
              Restaurant Hakkında Bilgi Al
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}